<script setup lang="ts">
import { useTranslations } from '@/composables/useTranslations.ts'
import type { ChatGptModel } from '@/components/projects/interfaces.ts'

defineProps<{
  modelValue: string,
  models: ChatGptModel[]
}>()

const { t } = useTranslations()

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()


function handleChange(e: Event) {
  const value = (e.target as HTMLSelectElement).value
  emit('update:modelValue', value)
}
</script>

<template>
  <div class="relative">
    <label class="block text-sm font-medium text-gray-700 mb-1">
      {{ t('settings.ai.assistant.model') }}
    </label>
    <select
      :value="modelValue"
      @change="handleChange"
      v-bind="$attrs"
      class="block w-full rounded-lg border px-3 py-2 text-gray-900 shadow-xs focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
    >
      <option
        v-for="model in models"
        :key="model.ID"
        :value="model.ID"
      >
        {{ model.ID }}
      </option>
    </select>
  </div>
</template>
